const pop_in = () => ({

    animation: {
        ['x-transition:enter']() {
            return 'transition ease-in-out duration-300';
        },
        ['x-transition:enter-start']() {
            return 'opacity-0 transform scale-y-0 -translate-y-1/2';
        },
        ['x-transition:enter-end']() {
            return 'opacity-100 transform scale-y-100 translate-y-0';
        }
    }
});

export default pop_in;